import React, { useEffect, useRef, useState } from 'react';
import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent,
    AlertDialogOverlay,
    AlertDialogProps,
    FormControl,
    Input,
    InputGroup,
    InputLeftElement,
    InputRightElement,
    Kbd
} from '@chakra-ui/react';
import { IoSearchSharp } from 'react-icons/io5';

type OwnProps = {
    defaultSearchKey: string;
    onSubmitSearch: (search: string) => void;
};

type Props = Pick<AlertDialogProps, 'isOpen' | 'onClose'> & OwnProps;

function SearchDialog(props: Props) {
    const { isOpen, defaultSearchKey, onClose, onSubmitSearch } = props;

    const cancelSearchRef = useRef<HTMLButtonElement>(null);

    const [searchKey, setSearchKey] = useState('');

    useEffect(() => {
        if (isOpen) {
            setSearchKey(defaultSearchKey);
        }
    }, [isOpen, defaultSearchKey]);

    const handleChangeSearchKey = (event: React.ChangeEvent<HTMLInputElement>) =>
        setSearchKey(event.target.value);

    const handleClickEnter = () => {
        console.log('hello')
    }

    const handleSubmitSearch = (event: React.FormEvent<HTMLDivElement>) => {
        event.preventDefault();

        onClose();
        onSubmitSearch(searchKey);
    };

    return (
        <AlertDialog
            size="xl"
            isOpen={isOpen}
            onClose={onClose}
            leastDestructiveRef={cancelSearchRef}
        >
            <AlertDialogOverlay />
            <AlertDialogContent className="bg-transparent">
                <AlertDialogBody className="p-0">
                    <FormControl
                        as="form"
                        onSubmit={handleSubmitSearch}
                    >
                        <InputGroup>
                            <InputLeftElement className="pointer-events-none left-5 top-1/2 -translate-y-1/2">
                                <IoSearchSharp
                                    size={20}
                                    className="text-primary-400"
                                />
                            </InputLeftElement>
                            <Input
                                size="lg"
                                value={searchKey}
                                placeholder="Search files"
                                onChange={handleChangeSearchKey}
                                className="h-16 border-0 bg-secondary-700 px-20 text-white shadow-none outline-0"
                            />
                            <InputRightElement className="right-5 top-1/2 -translate-y-1/2">
                                <button type="submit">
                                    <Kbd className="text-neutral-800">Enter</Kbd>
                                </button>
                            </InputRightElement>
                        </InputGroup>
                    </FormControl>
                </AlertDialogBody>
            </AlertDialogContent>
        </AlertDialog>
    );
}

export default SearchDialog;
